module.exports = __webpack_public_path__ + "img/Picture4.2cd5a50a.png";